import {
  Button,
  Link as LinkScl,
} from '@ace-clublabs/shared-component-library';
import { useEffect, useRef } from 'react';
import { Link, useBlocker } from 'react-router-dom';
import { constants } from '@/constants';
import useLandingPageRedirection from '@/hooks/useLandingPageRedirection';
import { Page } from '@/lib/tagging';
import useTagging from '@/lib/tagging/useTagging';
import useAppointmentStore, {
  isInBranchAppointment as isInBranchAppointmentSelector,
} from '@/store/AppointmentStore';
import useSessionStore from '@/store/SessionStore';
import AppointmentInformation from './AppointmentInformation';

function AppointmentCancelled() {
  useBlocker(
    ({ currentLocation, nextLocation }) =>
      currentLocation.pathname !== nextLocation.pathname,
  );
  const navigateTo = useLandingPageRedirection();
  const { selectedDestination, searchedDestination, contactInfo, userSearch } =
    useAppointmentStore();
  const isInBranchAppointment = useAppointmentStore(
    isInBranchAppointmentSelector,
  );
  const hasTagged = useRef(false);

  const { sessionSource, sessionId, flowType } = useSessionStore();

  const tagging = useTagging();

  useEffect(() => {
    if (!hasTagged.current) {
      const trvEndLocation =
        searchedDestination || userSearch || selectedDestination.name;

      const commPref = isInBranchAppointment ? 'in person' : 'phone';

      const contactType = contactInfo.communicationPreference?.toLowerCase();

      tagging.tag('view', sessionSource, {
        page: Page.cancelAppointment,
        sessionid: sessionId,
        flow: flowType,
        trv_end_location: trvEndLocation,
        comm_pref: commPref,
        contact_type: contactType,
      });

      hasTagged.current = true;
    }
  }, [
    searchedDestination,
    selectedDestination.name,
    sessionSource,
    sessionId,
    flowType,
    tagging.tag,
    contactInfo.communicationPreference,
    userSearch,
    isInBranchAppointment,
  ]);

  return (
    <AppointmentInformation
      isCancelled
      buttonGroup={{
        'data-testid': 'scheduleNewDateOrCloseButtonGroup',
        children: (
          <>
            <Link
              to={{ pathname: navigateTo }}
              reloadDocument
              style={{ width: '100%' }}
            >
              <Button label='Schedule new appointment' fullWidth />
            </Link>
            <LinkScl
              href={constants.TRAVEL_HOME_PAGE_URL}
              sx={{ width: '100%' }}
              data-testid='closePageButtonLink'
            >
              <Button
                label='Close page'
                fullWidth
                variant='outlined'
                href={constants.TRAVEL_HOME_PAGE_URL}
              />
            </LinkScl>
          </>
        ),
      }}
    />
  );
}

export default AppointmentCancelled;
